import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {User} from "../../user/user";
import {AuthService} from "../../auth/auth.service";
import {DbResponse} from "../../shared/interceptors/db-response";
import {ChangeEmailSuccessComponent} from "../change-email-success/change-email-success.component";
import {DbValidators} from "../../shared/validators/DbValidators";
import {UserSubscriptionIds} from "../../user/user-subscription";
import {filter, first} from "rxjs/operators";


@Component({
    selector: 'db-change-email',
    templateUrl: 'change-email.component.html',
    styleUrls: ['change-email.component.scss'],
    standalone: false
})
export class ChangeEmailComponent extends DialogComponent<null, boolean> implements OnInit {
  public loading: boolean;
  public formSubmitted: boolean;
  public changeEmail: FormGroup;
  public showPassword: boolean = false;
  public serverErrors: any;
  @Input() user: User;

  constructor(
    private _dialogService: DialogService,
    private _authService: AuthService,
  ) {
    super(
      _dialogService
    );

  }

  ngOnInit() {
    if (this.user && this.user.subscriptionId === UserSubscriptionIds.TRIAL) {
      this.changeEmail = new FormGroup({
        'newEmail': new FormControl('', [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
        'reEnterEmail': new FormControl('', [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
        'password': new FormControl('', [Validators.required, DbValidators.trim]),
      }, this.checkIfMatchingEmails('newEmail', 'reEnterEmail'));
    } else {
      this.changeEmail = new FormGroup({
        'newEmail': new FormControl('', [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
        'reEnterEmail': new FormControl('', [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
        'password': new FormControl('', [Validators.required, DbValidators.trim]),
      }, this.checkIfMatchingEmails('newEmail', 'reEnterEmail'));
    }
  }

  public checkIfMatchingEmails(newEmail: string, reEnterEmail: string): any {
    return (group: FormGroup) => {
      let emailInput = group.controls[newEmail],
        emailConfirmationInput = group.controls[reEnterEmail];
      if (emailInput.value !== emailConfirmationInput.value) {
        return emailConfirmationInput.setErrors({notEquivalent: true});
      }
      else {
        return emailConfirmationInput.setErrors(null);
      }
    };
  }

  public submitReset(): void {
    this.formSubmitted = true;
    if ( this.changeEmail.valid ) {
      this.loading = true;
      this._authService.changeEmail(this.changeEmail.controls['newEmail'].value, this.changeEmail.controls['password'].value)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          this.loading = false;
          if (response.success) {
            this.close();
            this._dialogService.addDialog(ChangeEmailSuccessComponent);
          }
          else {
            this.serverErrors = response;
          }
        });
    }
  }


  public togglePassword() {
    this.showPassword = !this.showPassword;
  }


}
